import { ProfileState } from './types'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const state: ProfileState = {
  userID: 0,
  displayName: '',
  email: '',
  profileURL: '',
  activate: false,
  uniqueID: '',
  allowChangeEmail: false,
  changingEmail: '',
  providers: [],
  riskProfile: '',
  tel: ''
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
